var exports = {
  "kL": "xe564cbfb--d15dc1--container",
  "DD": "xe564cbfb--d15dc1--title",
  "Kk": "xe564cbfb--d15dc1--icon",
  "x6": "xe564cbfb--d15dc1--button",
  "LX": "xe564cbfb--d15dc1--builders",
  "XO": "xe564cbfb--d15dc1--builder-link",
};

module.exports = exports;
